import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { TabPanel } from "@material-ui/lab";
import MapaSalas from "./MapaSalas";
import MapaSalaSSRE from "./MapaSSRE";

interface StyledTabsProps {
  value: number;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 40,
      width: "100%",
      backgroundColor: "#24135f",
    },
  },
})((props: StyledTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span /> }} centered={true} />
));

interface StyledTabProps {
  label: string;
}

const StyledTab = withStyles({
  root: {
    textTransform: "none",
    color: "#fff",
    marginRight: 8,
    "&:focus": {
      opacity: 1,
    },
  },
})((props: StyledTabProps) => <Tab disableRipple {...props} />);

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: 2,
  },
  demo2: {
    backgroundColor: "#b1a252",
  },
});

const PIETab = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <div className={classes.demo2}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
        >
          <StyledTab label="Sala Superior" />
          <StyledTab label="Salas Regionales" />
          <StyledTab label="Sala Regional Especializada" />
        </StyledTabs>
        <Typography className={classes.padding} />
      </div>
      {value === 1 ? <MapaSalas /> : <MapaSalaSSRE index={value} />}
    </>
  );
};

export default PIETab;
